import React, { useState, useCallback, Fragment } from "react";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormBudget from "../../../../containers/modules/accounting/budget/form";
import FormUpload from "../../../../containers/modules/accounting/budget/upload";
import Table from "../../../utilities/table";
import LabelApprove from "../../../utilities/Status/approve-customer";
import { Approval } from "../../../utilities/Const/TranscationCode";

const MySwal = withReactContent(Swal);

const Budget = (props) => {
  const {
    isProcessing,
    authUser,
    datalist ,
    search,
    showModal,
    createData,
    voidItem,
    rejectItem,
    approveItem
    
  } = props;
  const [searchState, setSearchState] = useState({ limit: 10 });
  const [titleModal, setTitleModal] = useState("");
  const [show, setShow] = useState(1);
  const [listData, setListData] = useState([]);
  console.log('PROPS', props);
  const breadcrumbs = [
    { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
    { link: null, title: i18n.t("Accounting"), class: " text-gray-600" },
    { link: null, title: i18n.t("Budget"), class: " text-gray-500" },
  ];

  const column = [
    { key: "date_format", filter: { active: true, type: "Date" }, title: i18n.t("Date"), type: "text", tHclass: "min-w-100px" },
    { key: "branch_name", filter: { active: true, type: "Text" }, title: i18n.t("Branch"), type: "text", tHclass: "min-w-150px" },
    { key: "name", filter: { active: true, type: "Text" }, title: i18n.t("Name"), type: "text", tHclass: "min-w-150px" },
    { key: "coaAccount", filter: { active: true, type: "Text" }, title: i18n.t("Account"), type: "text", tHclass: "min-w-150px" },
    { key: "limit_format", filter: { active: false, type: "Text" }, title: i18n.t("Limit"), type: "text", tHclass: "min-w-150px" },
    { key: "status",filter: {active: true, type: "Select",data: Approval},title: i18n.t("Status"),type: "component", tHclass: "min-w-125px",tdClass: "",
        component: (data, column) => {
          return <LabelApprove value={data[column.key]} />;
        },
      },
    { key: "createdAt", filter: { active: false }, title: i18n.t("Created At"), type: "custom", tHclass: "text-center min-w-125px" },
    { key: "updatedAt", filter: { active: false }, title: i18n.t("Updated At"), type: "custom", tHclass: "text-center min-w-125px" },
    {
        key: "id",
        filter: {
          active: false,
        },
        title: i18n.t("Action"),
        type: "action",
        tHclass: "text-center min-w-150px",
        tdClass: "text-center",
        form:'icon',
        buttons: [
          {
            key: "id",
            btnText:i18n.t("Edit"),
            visible: {
              key: "status",
              params: [10],
              function: (id, params) => {
                return params.includes(id);
              },
            },
            btnFunction: (data, column) => {
              updateData(data);
            },
            bthClass: "btn btn-warning",
          },{
            key: "id",
            btnText: i18n.t("Approve"),
            visible: {
              key: "status",
              params: [1],
              function: (id, params) => {
                if(params.includes(id)){
                  if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
                    let route=authUser.userAccess.route
                    if(route.includes('Budget Approve')){
                      return true
                    }
                  }
                  return false;
                }
              }
              },
            btnFunction: (data, column) => {
             approveData(data);
            },
            bthClass: "btn btn-warning",
          },
          {
            key: "id",
            btnText: i18n.t("Reject"),
            visible: {
              key: "status",
              params: [1],
              function: (id, params) => {
                if(params.includes(id)){
                  if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
                    let route=authUser.userAccess.route
                    if(route.includes('Budget Reject')){
                      return true
                    }
                  }
                  return false;
                }
              }
            },
            btnFunction: (data, column) => {
              rejectData(data);
            },
            bthClass: "btn btn-warning",
          },
          {
            key: "id",
            btnText: i18n.t("Delete"),
            visible: {
              key: "status",
              params: [2,3],
              function: (id, params) => {
                if(params.includes(id)){
                  return true;
                }
              },
            },
            btnFunction: (data, column) => {
              deleteData(data);
            },
            bthClass: "btn btn-danger",
          },
        ],
      },
    ];
    // console.log('PROPS',props)
  // 🔍 Search handler
  const runSearch = useCallback(
    (value) => {
      search(value);
    },
    [search]
  );

  const createNewData = () => {
    setTitleModal(i18n.t("Add Budget"));
    createData();
    setShow(1);
  };


  const deleteData = (data) => {
    const html = (
      <>
        <div>{i18n.t("You Will Delete This Data")}</div>
        <Button variant="warning" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            voidItem(data, searchState);
            MySwal.update({
              title: i18n.t("Delete Data"),
              html: i18n.t("Please Wait ...."),
              icon: i18n.t("info"),
            });
            MySwal.showLoading();
          }}
        >
          {i18n.t("Accept")}
        </Button>
      </>
    );

    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html,
      icon: i18n.t("question"),
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  };

   const rejectData = (id) => {
    const html = (
      <>
        <div>{i18n.t("Reject This Data")}</div>
        <Button variant="secondary" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            MySwal.fire({
              title: i18n.t("Enter your message"),
              icon: false,
              input: "textarea",
              inputValue: "",
              showCancelButton: true,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                if (!value) {
                  return i18n.t("You need to write something!");
                }
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const value = result.value;
                MySwal.fire({
                  title: i18n.t("Proccessing Data"),
                  html: i18n.t("Please Wait ...."),
                  icon: "info",
                });
                MySwal.showLoading();
                rejectItem(id, value, searchState);
              }
            });
          }}
        >
          {i18n.t("Reject")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }

  const approveData = (id) => {
    const html = (
      <>
        <div>{i18n.t("Approve This Data")}</div>
        <Button variant="secondary" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="success"
          onClick={() => {
            MySwal.fire({
              title: i18n.t("Enter your message"),
              icon: false,
              input: "textarea",
              inputValue: "",
              showCancelButton: true,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                if (!value) {
                  return i18n.t("You need to write something!");
                }
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const value = result.value;
                MySwal.fire({
                  title: i18n.t("Proccessing Data"),
                  html: i18n.t("Please Wait ...."),
                  icon: "info",
                });
                MySwal.showLoading();
                approveItem(id, value, searchState);
              }
            });
          }}
        >
          {i18n.t("Approve")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }

  React.useEffect(() => {
    setListData(datalist);
  }, [datalist]);

  return (
    <Fragment>
      <div id="customer-type">
        <Breadcrumbs url={breadcrumbs} tools={false} />

        <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-fluid">
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-header d-flex justify-content-end border-0 pt-6">
                <div className="card-toolbar">
                  <div className="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
                    <Button type="button" className="btn btn-warning m-1" onClick={() => runSearch(searchState)}>
                      <FontAwesomeIcon icon={faSync} />
                    </Button>
                    <Button type="button" className="btn btn-primary m-1" onClick={createNewData}>
                      {i18n.t("Add Budget")}
                    </Button>
                    {/* <Button type="button" className="btn btn-success m-1" onClick={uploadData}>
                      {i18n.t("Upload Beginning Balance")}
                    </Button> */}
                  </div>
                </div>
              </div>

              <div className="card-body pt-0">
                <Table
                  data={listData}
                  tools={false}
                  filterSearch={true}
                  column={column}
                  searchData={searchState}
                  runSearch={runSearch}
                  isProcessing={isProcessing}
                />
              </div>
            </div>
          </div>
        </div>

        {show === 1 ? (
          <FormBudget showModal={showModal} search={searchState} titleModal={titleModal} {...props}/>
        ) : (
          <FormUpload showModal={showModal} search={searchState} titleModal={titleModal} />
        )}
      </div>
    </Fragment>
  );
};

export default Budget;
